module.exports = __webpack_public_path__ + "images/柏纳长图_07.jpg?v=974e165b";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_07.jpg
 ** module id = 147
 ** module chunks = 1 2
 **/